import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const TravelChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const { timeText } = eventInfo.event.extendedProps;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      className="bg-zinc-200 dark:bg-zinc-600 border-dotted border-zinc-400 dark:border-zinc-700 text-foreground"
    >
      <span>{timeText}</span>
      <span className="truncate">{eventInfo.event.title}</span>
    </CalendarChip>
  );
};
